import { render } from "./PatientExamNewOffcanvas.vue?vue&type=template&id=a09edd06&scoped=true"
import script from "./PatientExamNewOffcanvas.vue?vue&type=script&lang=js"
export * from "./PatientExamNewOffcanvas.vue?vue&type=script&lang=js"

import "./PatientExamNewOffcanvas.vue?vue&type=style&index=0&id=a09edd06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a09edd06"]])

export default __exports__